<template>
  <div class="global-search-menu-filter">
    <span>
      {{ getComponentUiText("app-header-menu-search-text-filter-1") }}
    </span>
    <CustomCheckBox
      v-for="item in arrayFilters"
      :key="item.id"
      :title="getComponentUiText(item.title)"
      class="global-search-menu-right-checkbox-item"
      :is-checked="selectedFilterIds.includes(item.id)"
      :size="'20px'"
      :disabled="
        item.id === TopicName.all && selectedFilterIds.includes(item.id)
      "
      color-checkmark="#01893D"
      @update:is-checked="onSelect($event, item.id)"
    />
  </div>
</template>

<script setup lang="ts">
import { getComponentUiText } from "@/utils/utilities";

/** components */
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import { TopicName } from "@/components/common/globalSearch/constants";

const props = defineProps<{
  selectedFilterIds: string[];
}>();

const emit = defineEmits<{
  (e: "on-select", ids: string[]): void;
}>();

const arrayFilters = [
  {
    id: TopicName.all,
    title: "app-header-menu-search-option-filter-all-1",
  },
  {
    id: TopicName.page,
    title: "app-header-menu-search-option-filter-page-1",
  },
  {
    id: TopicName.org,
    title: "app-header-menu-search-option-filter-org-1",
  },
  {
    id: TopicName.assessment,
    title: "app-header-menu-search-option-filter-assessment-1",
  },
  {
    id: TopicName.recommend,
    title: "app-header-menu-search-option-filter-recommendations-1",
  },
  {
    id: TopicName.help,
    title: "app-header-menu-search-option-filter-help-topics-1",
  },
  {
    id: TopicName.setting,
    title: "app-header-menu-search-option-filter-settings-1",
  },
];

const onSelect = (isChecked: boolean, id: string) => {
  if (id === TopicName.all) {
    return emit("on-select", [isChecked ? TopicName.all : TopicName.page]);
  }
  const ids = props.selectedFilterIds.filter(
    (item) => item !== TopicName.all && item !== id,
  );
  if (isChecked) {
    ids.push(id);
  }
  return emit("on-select", !ids.length ? [TopicName.all] : ids);
};
</script>

<style lang="scss" scoped>
.global-search-menu-filter {
  display: flex;
  flex-direction: column;
  width: 220px;
  max-width: 220px;
  min-width: 220px;
  padding: 25px;
  gap: 25px;
  border: 1px solid #eff0f1;
  border-left: none;
  & > span {
    font-family: Poppins, sans-serif;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    float: right;
    letter-spacing: 1.5px;
    user-select: none;
    color: #211f58;
  }
}
</style>

<style>
.global-search-menu-right-checkbox-item {
  margin: unset !important;
  &&& > span[class*="title"] {
    font-family: Poppins, sans-serif;
    font-weight: 400;
    font-size: 13px;
    color: #211f58;
  }
}
</style>
